// Collapsible.js
import React, { useState, useRef, useEffect  } from "react";
import "./Collapsible.css"; // Optional: Include any styles here
import { FaChevronDown } from "react-icons/fa";

const Collapsible = ({ collapsibleData }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleCollapse = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (activeIndex !== null) {
      // Open the clicked content with sliding down effect
      contentRefs.current[activeIndex].style.maxHeight = contentRefs.current[activeIndex].scrollHeight + "px";
    }
    contentRefs.current.forEach((ref, index) => {
      if (index !== activeIndex && ref) {
        // Close other contents with sliding up effect
        ref.style.maxHeight = "0px";
      }
    });
  }, [activeIndex]);


  return (
    <div>
      {collapsibleData.map((item, index) => (
        <div key={index}>
          <button
            className={`collapsible ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleCollapse(index)}
          >
            {item.title} <FaChevronDown className={`icon ${activeIndex === index ? "rotate" : ""}`}/>
          </button>
          <div
            ref={(el) => (contentRefs.current[index] = el)}
            className="content"
           
          >
            <div className="content-inner">{item.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Collapsible;
